import React, { useContext, useEffect, useState } from 'react';
import './Login.css';
import axios from 'axios';
import { serverUrl } from '../../../../Constant/Static/config';
import Header from '../../../Registration/Header';
import peopleIcon from '../../../../Constant/Icons/people.svg';
import userName from '../../../../Constant/Icons/username.svg';
import passwordIcon from '../../../../Constant/Icons/password.svg'
import eyeIcon from '../../../../Constant/Icons/eye.svg';
import user from '../../../../Constant/Icons/user.svg';
import eyeSlashIcon from '../../../../Constant/Icons/eyehide.svg';
import PopModal from '../../../../Constant/Custom/Models/PopModal';
import { useNavigate, useLocation } from 'react-router-dom';



const CollegeLogin = () => {



    const [formData, setFormData] = useState({
        username: '',
        password: '',
    });

    const [showPassword, setShowPassword] = useState(false);
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [modalType, setModalType] = useState({ title: '', text: '', icon: '' });

    const openModal = () => setIsModalOpen(true);
    const closeModal = () => setIsModalOpen(false);
    const navigate = useNavigate();

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData((prevFormData) => ({
            ...prevFormData,
            [name]: value,
        }));
    };

    const handlePasswordVisibility = () => {
        setShowPassword(!showPassword);
    };

    const handleSubmit = async (e) => {

        e.preventDefault();


        if (!formData.username || !formData.password) {
            setModalType({
                icon: 'warning',
                title: 'Invalid Input',
                text: 'Username and password cannot be empty.',
            });
            openModal();
            return;
        }

        const dataToSend = {
            username: formData.username.trim(),
            password: formData.password.trim(),
        };

        try {

            const response = await axios.post(`${serverUrl}/api/college/login`, dataToSend);
            if (response.status === 200 && response.data.changed === '0') {
                setModalType({
                    icon: 'success',
                    title: 'Reset Your Password !',
                    text: response.data.message,
                });
                openModal();

                navigate('/college-reset');


            }
            else if (response.status === 200) {
                setModalType({
                    icon: 'success',
                    title: 'Login Successful!',
                    text: response.data.message,
                });
                openModal();
                // console.log(response.data.collegeName);



                sessionStorage.setItem('CollegeName', response.data.collegeName);
                sessionStorage.setItem('collegeCode', response.data.collegecode);
                navigate('/college-dashboard');

            }

        } catch (err) {
            // console.log(err.response);
            const errorMessage = err.response?.data?.message || 'An error occurred. Please try again.';
            setModalType({
                icon: `${!err.response?.data?.sucess ? 'error' : 'warning'}`,
                title: `${!err.response?.data?.sucess ? 'Invalid user' : 'Login Failed!'}`,
                text: errorMessage,
            });
            openModal();
            // console.log(errorMessage);
        }
    };

    const handleCancel = () => {
        setFormData({
            username: '',
            password: '',
        });
        closeModal();
    };

    // useEffect(() => {
    //     const checkSession = () => {
    //         try {
    //             const response = localStorage.getItem('user');
    //             if (response) {
    //                 // Redirect the user if they already have an active session
    //                 // loginUser();
    //                 navigate('/dashboard');
    //             }
    //         } catch (error) {
    //             console.error('Error checking session:', error);
    //         }
    //     };
    //     checkSession();
    // }, [navigate]);


    return (
        <div style={{ width: '100dvw', height: '100dvh', backgroundColor: '#f9f9f9' }}>
            <Header>
                <a href='/college-login'>
                    <img src={user} alt='Login' width={50} height={50} />
                </a>
            </Header>


            <div className="login-container">
                <h3 style={{
                    textAlign: "center",

                    fontFamily: "Segoe UI, Roboto, sans-serif",
                    letterSpacing: "1px",
                    fontWeight: "600",
                    textTransform: "uppercase"
                }}>
                    TNLEA 2026  :: Vacancy & Seat  Allotment Details
                </h3>
                <br/>
                <div className="login-inner-container">
                    <h1 style={{
                        textAlign: "center",

                        fontFamily: "Segoe UI, Roboto, sans-serif",
                        letterSpacing: "1px",
                        fontWeight: "600",
                        textTransform: "uppercase"
                    }}>
                        COLLEGE LOGIN
                    </h1>
                    <img src={peopleIcon} alt="user" width={75} height={75} />
                    <form onSubmit={handleSubmit}>
                        <div className="login-form-group">
                            <input
                                type="text"
                                name="username"
                                value={formData.username}
                                placeholder="Enter College Code "
                                onChange={handleChange}
                                required
                            />
                            <img className="IconForInput" src={userName} alt="user" width={20} height={20} />
                        </div>
                        <div className="login-form-group">
                            <input
                                type={showPassword ? "text" : "password"}
                                name="password"
                                value={formData.password}
                                placeholder="Enter Password"
                                onChange={handleChange}
                                required
                            />
                            <img className="IconForInput" src={passwordIcon} alt="user" width={20} height={20} />
                            <button
                                type="button"
                                className="toggle-password"
                                onClick={handlePasswordVisibility}
                                aria-label={showPassword ? 'Hide Password' : 'Show Password'}
                            >
                                <img src={showPassword ? eyeSlashIcon : eyeIcon} alt="toggle password visibility" width={20} height={20} />
                            </button>
                        </div>
                        {/* <div className="login-form-group" style={{ alignSelf: 'flex-end' }}>
                            <a href="/forgot-password" className="forgot-password-link">Forgot Password?</a>
                        </div> */}
                        <div className="login-form-group">
                            <button type="submit" className="login-button">LogIn</button>
                        </div>
                    </form>
                    <div
                        style={{
                            position: 'relative',
                            alignSelf: 'center',
                            display: 'flex',
                            justifyContent: 'center',
                            alignItems: 'center',
                        }}
                    >
                        {/* <svg
                            height={10}
                            width="100%"
                            xmlns="http://www.w3.org/2000/svg"
                        >
                            <line
                                x1="0%"
                                y1="55%"
                                x2="100%"
                                y2="55%"
                                style={{
                                    stroke: '#1C274C',
                                    strokeWidth: 0.25,
                                    filter: 'drop-shadow(0px 2px 4px rgba(0, 0, 0, 0.25))',
                                }}
                            />
                        </svg> */}
                        <div
                            style={{
                                position: 'absolute',
                                backgroundColor: '#f9f9f9',
                                padding: '5px 5px',
                                borderRadius: '50%',
                                zIndex: '1000',
                            }}
                        >

                        </div>
                    </div>
                    {/* <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', margin: '0% 2%' }}>
                        <h5 style={{ color: '#1C274C' }}><a href="/register" className='apply-register'>New Registration?</a></h5>
                    </div> */}
                    <div style={{ position: 'relative', alignSelf: 'center', display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                        <PopModal
                            isOpen={isModalOpen}
                            type={modalType}
                            confirmButtonText="OK"
                            onConfirm={handleCancel}
                        />
                    </div>
                </div>
            </div>
        </div>
    );
};

export default CollegeLogin;
